import script from "./Home-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Home-item.vue?vue&type=script&setup=true&lang=js"

import "./Home-item.vue?vue&type=style&index=0&id=68757eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68757eb2"]])

export default __exports__